import { type SearchFilterString } from '@air/api/types';

export const getAppliedParamsCount = (param?: SearchFilterString | null) =>
  (param?.and?.length ?? 0) + (param?.or?.length ?? 0) + (param?.not?.length ?? 0);

export const getAppliedParamsValues = (param?: SearchFilterString | null) => {
  return [param?.and, param?.or, param?.not].flatMap((arr) => arr ?? []);
};
